import React from 'react';
import PropTypes from 'prop-types';
import InnerHTML from '@Components/InnerHTML';
import DocumentHitsFormat from '@Components/Results/services/document-hits-format.service';
import { ClickableCard } from '@els/els-react--card';
import { Icon } from '@els/els-react--icon';

function DocumentIndexTermsHit({ keywords, onOpen, trackingAttrs }) {
  const indexTermsHit = DocumentHitsFormat.checkAndFormatIndexTermsHit(keywords);

  return indexTermsHit ? (
    <ClickableCard
      data-e2e="index-terms-hit-open"
      className="result-detail-panel e2e-document-action-index-terms-hit"
      aria-label="Open Index Terms"
      {...trackingAttrs}
      onClick={onOpen}>
      <div className="u-els-display-flex document-hit-card__content">
        <h3 className="u-els-margin-right-1o2 u-els-font-family-bold u-els-font-size-base document-hit-card__title">Index Terms Hit:</h3>
        <InnerHTML tag="div" className="result-detail-block u-els-font-size-base document-hit-card__text" html={indexTermsHit} />
        <Icon
          sprite="ChevronDown"
          size="xs"
          isDecorative
          className="u-els-margin-left-1o2 result-detail-panel__chevron document-hit-card__chevron"
        />
      </div>
    </ClickableCard>
  ) : null;
}

DocumentIndexTermsHit.propTypes = {
  keywords: PropTypes.array.isRequired,
  onOpen: PropTypes.func.isRequired,
  // for analytics
  trackingAttrs: PropTypes.object.isRequired,
};

export default DocumentIndexTermsHit;
